module.exports = __webpack_public_path__ + "img/loadingeclips.3277f6a1.svg";